import styled from 'styled-components';

const SpanRight = styled.span`
    float: right;
`;

const Line = styled.div<{ inActive: boolean }>`
    line-height: 2.5;
    padding-left: 10px;
    ${({ inActive }) => inActive && 'color: #dadada;'}
`;

const ColoredSquare = styled.span<{ inActive: boolean }>`
    display: inline-block;
    height: 10px;
    width: 10px;
    border: 1px solid black;
    clear: both;
    background-color: ${({ color }) => color};
    ${({ inActive }) => inActive && 'opacity: 0.2'}
`;

export { ColoredSquare, Line, SpanRight };
